<template>
  <router-view />
</template>

<script>
export default {
  name: 'TaxiDriversIndex'
}
</script>
